import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabaseEnabled } from '../config/supabase';

const Notice: React.FC<{ kind: 'warn' | 'err'; children: React.ReactNode }> = ({ kind, children }) => (
  <div className="page">
    <div className={`pill ${kind === 'warn' ? 'pill-warn' : 'pill-err'}`} style={{ height: 'auto', padding: '12px 16px', borderRadius: 12, width: '100%' }}>
      {children}
    </div>
  </div>
);

const RequireSuperAdmin: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { session, loading, claims } = useAuth();
  const location = useLocation();

  if (!supabaseEnabled) {
    return <Notice kind="warn">Supabase Auth nieskonfigurowane — panel super-admina wymaga REACT_APP_SUPABASE_URL.</Notice>;
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <div className="spinner" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  if (!claims.is_super_admin) {
    return <Notice kind="err">Brak uprawnień super-admina. Zaloguj się na konto z wpisem w tabeli super_admins.</Notice>;
  }

  return <>{children}</>;
};

export default RequireSuperAdmin;
